import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ACCESS from 'utils/Access'
import { Loader, Input } from '@driftt/tide-core-legacy'

import { fetchAttributes } from 'app/modules/endUser/attribute/actions'
import { filteredProperties } from 'app/modules/endUser/attribute/selectors'
import { fetchSFDCProperties, fetchSFDCContactProperties, fetchSFDCMappings, patchSFDCMappings } from 'app/modules/sfdc/actions'
import { SFDCMapping } from 'app/modules/sfdc/models'
import AttributeMapper from '../../components/AttributeMapper'

import ErrorState from './ErrorState'
import withNotifications from 'components/shared/notifications'
import './style.styl'

const integrationName = 'Salesforce'
const getSuccessMessage = (integrationName) => `You successfully updated your ${integrationName} App!`

class LeadContactPropertyMapping extends Component {

  constructor(props){
    super(props)

    setTimeout(() => this.setState({ loaded: this.allDataHasLoaded(this.props) }), 750)

    this.state = {
      loaded: false,
      useStateAcronyms: this.props.useStateAcronyms,
      useCountryAcronyms: this.props.useCountryAcronyms,
      allowAttributeDefaults: this.props.allowAttributeDefaults
    }
  }
  onDefaultToggled = () => {
    const { allowAttributeDefaults } = this.state
    const { mappings, notifications } = this.props
    const defaultMapping = {
      mappings: mappings,
      allowAttributeDefaults: !allowAttributeDefaults
    }
    this.setState({ allowAttributeDefaults: !allowAttributeDefaults })
    this.props.actions.patchSFDCMappings(defaultMapping, true, () => notifications.success(getSuccessMessage(integrationName)))
  }

  onCountryToggled = () => {
    const { useCountryAcronyms } = this.state
    const { mappings, notifications } = this.props
    const countryMapping = {
      mappings: mappings,
      useCountryAcronyms: !useCountryAcronyms
    }
    this.setState({ useCountryAcronyms: !useCountryAcronyms })
    this.props.actions.patchSFDCMappings(countryMapping, true, () => notifications.success(getSuccessMessage(integrationName)))
  }

  onStateToggled = () => {
    const { useStateAcronyms } = this.state
    const { mappings, notifications } = this.props
    const stateMapping = {
      mappings: mappings,
      useStateAcronyms: !useStateAcronyms
    }
    this.setState({ useStateAcronyms: !useStateAcronyms })
    this.props.actions.patchSFDCMappings(stateMapping, true, () => notifications.success(getSuccessMessage(integrationName)))
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.useCountryAcronyms !== nextProps.useCountryAcronyms) {
      this.setState({ useCountryAcronyms: nextProps.useCountryAcronyms })
    }

    if (this.props.useStateAcronyms !== nextProps.useStateAcronyms) {
      this.setState({ useStateAcronyms: nextProps.useStateAcronyms })
    }
    if (this.props.allowAttributeDefaults !== nextProps.allowAttributeDefaults) {
      this.setState({ allowAttributeDefaults: nextProps.allowAttributeDefaults })
    }

    if (!this.state.loaded && this.allDataHasLoaded(nextProps)) {
      setTimeout(() => this.setState({ loaded: true }), 750)
    }
  }

  allDataHasLoaded = props => (
    props.mappings && 
    props.driftProperties && props.driftProperties.length > 0 &&
    props.sfdcProperties && props.sfdcProperties.length > 0
  )

  componentWillMount() {
    const hasAccess = ACCESS.hasGates('SALESFORCE_MAPPING')
    !hasAccess && window.location.replace('/settings/setup/salesforce/')
  }

  componentDidMount() {
    this.props.actions.fetchDriftProperties()
    this.props.isLeadMapping ? this.props.actions.fetchSFDCProperties() : this.props.actions.fetchSFDCContactProperties()
    this.props.actions.fetchSFDCMappings()
  }

  patchDecorator = (strippedMappings, successCB) => {
    const { mappings, sfdcProperties } = this.props
    const hiddenMappings = mappings.filter(mapping => !_.find(sfdcProperties, { name:  mapping.integrationAttribute }))
    this.props.actions.patchSFDCMappings(strippedMappings.concat(hiddenMappings), false, successCB)
  }

  render() {
    const { mappings } = this.props

    if (this.props.mappingsError || this.props.attributesError)
      return <ErrorState />

    if (!this.state.loaded)
      return <Loader className= "salesforce-mapping-loader"/>

    return (
      <div>
        <AttributeMapper
          integrationName= {integrationName}
          mappings={mappings.filter(mapping => _.find(this.props.sfdcProperties, { name:  mapping.integrationAttribute }))}
          driftAttributes={this.props.driftProperties}
          integrationAttributes={this.props.sfdcProperties}
          mappingModel={SFDCMapping}
          patchMappings={this.patchDecorator}
          patchLoading={this.props.sfdcPatchLoading}
          allowAttributeDefaults={this.state.allowAttributeDefaults}
        />
        <div className="salesforce-toggle-table">
          <div className="salesforce-toggle-row">
            <Input className= "salesforce-acronym-toggle"
              type="checkbox"
              checked={this.state.allowAttributeDefaults}
              onChange={this.onDefaultToggled}/>
            <h1 className="salesforce-toggle-text">Set default values that will send when a Drift Attribute is empty</h1>
          </div>
          <div className="salesforce-toggle-row">
            <Input className= "salesforce-acronym-toggle"
              type="checkbox"
              checked={this.state.useCountryAcronyms}
              onChange={this.onCountryToggled}/>
            <h1 className="salesforce-toggle-text">Send abbreviated country names to Salesforce (i.e. US instead of United States)</h1>
          </div>
          <div className="salesforce-toggle-row">
            <Input className= "salesforce-acronym-toggle"
              type="checkbox"
              checked={this.state.useStateAcronyms}
              onChange={this.onStateToggled}/>
            <h1 className="salesforce-toggle-text">Send abbreviated state names to Salesforce (i.e. NY instead of New York)</h1>
          </div>
        </div>
      </div>
    )
  }
}

LeadContactPropertyMapping.defaultProps = {
  mappings: [],
  useCountryAcronyms: false,
  useStateAcronyms: false,
  allowAttributeDefaults: false
}

function mapStateToProps(state) {
  return {
    driftProperties: filteredProperties(state),
    mappings: state.get('sfdc').mappings,
    sfdcProperties: state.get('sfdc').sfdcProperties,
    mappingsError: state.get('sfdc').sfdcMappingsErr,
    attributesError: state.get('sfdc').sfdcAttributesErr,
    sfdcPatchLoading: state.get('sfdc').sfdcPatchLoading,
    useCountryAcronyms: state.get('sfdc').useCountryAcronyms,
    useStateAcronyms: state.get('sfdc').useStateAcronyms,
    allowAttributeDefaults: state.get('sfdc').allowAttributeDefaults
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchDriftProperties: fetchAttributes,
      fetchSFDCMappings,
      fetchSFDCProperties,
      fetchSFDCContactProperties,
      patchSFDCMappings,
    }, dispatch)
  }
}

export default withNotifications(connect(mapStateToProps, mapDispatchToProps)(LeadContactPropertyMapping))



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/SalesforceMapping/LeadContactPropertyMapping.js